import { render, staticRenderFns } from "./SangomaAICTAModal.vue?vue&type=template&id=2b775d3c&"
import script from "./SangomaAICTAModal.vue?vue&type=script&lang=js&"
export * from "./SangomaAICTAModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports